module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_6005.33ff52f6.png";